import React from 'react';
import { Route } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import HouseKeepingContainer from './HouseKeeping';

export const HouseKeepingModule = () => (
  <Route
    exact
    path={APP_ROUTES.OPERATION_MODULE.CHILDREN?.HOUSE_KEEPING.PATH}
    component={HouseKeepingContainer}
  />
);
